import "./index.css";

function ProfileTitle(props) {
	return (
		<h1 className="profile-title poppins-font">
			Atualizar dados vacinais
		</h1>
	);
}

export default ProfileTitle;